import { css } from "@emotion/react";

export const styles = {
  description: css`
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    color: #0045b5;
    margin-top: 16px;
  `,
  informative_description: css`
    font-size: 16px;
    text-align: left;
    margin-top: 16px;
    color: rgba(0, 56, 99, 0.7);
    text-transform: none;
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;

    margin-bottom: 16px;

    ul,
    ol {
      padding-inline-start: 18px;
    }
  `,
  partner: css`
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
  `,
  partnercard__title: css`
    font-size: 24px;
    font-weight: 600;
    color: #0045b5;
    text-align: left;
  `,
  points: css`
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
    text-align: left;
    color: #ff8b00;
    margin-top: 16px;
  `,
  validity: css`
    font-size: 12px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: left;
    min-height: 36px;
  `,
  validity_title: css`
    font-size: 12px;
    font-weight: 700;
    line-height: 16.8px;
    text-align: left;
  `,
  button: css`
    background-color: #0045b5;
    height: 48px;
    text-transform: uppercase;
    font-weight: 300;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 20px;
    width: fit-content;
    align-self: center;
    &:hover {
      background-color: #003399;
    }
  `
};
